<template>
  <div v-if="shouldHideNavigation" class="footer">
    <div class="footer__inner container">
      <div class="footer__main">
        <div class="footer__main-col is-logo">
          <p class="footer__logo-label">Logo</p>
          <logo tag="a" to="/" class="footer__logo" aria-label="Public Trust Home" />
        </div>
        <div class="footer__main-col is-nav">
          <footer-nav :items="nav" class="footer__nav" />
        </div>
        <div class="footer__main-col is-socials">
          <div class="footer__actions">
            <pt-button v-if="signUpUrl" type="primary" size="full" tag="a" :href="signUpUrl" target="_blank" rel="external"> Sign up </pt-button>
            <pt-button v-if="loginUrl" type="secondary_inverted" size="full" tag="a" :href="loginUrl" target="_blank" rel="external">
              Log in
            </pt-button>
          </div>
          <footer-socials class="footer__socials" />
        </div>
      </div>
      <div class="footer__secondary">
        <footer-secondary-nav :items="secondaryNav" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import Logo from '~/components/global/elements/Logo.vue';
import FooterNav from '~/components/ui/layout/footer-nav/FooterNav.vue';
import FooterSocials from '~/components/ui/layout/footer-nav/FooterSocials.vue';
import { transformNavItem } from '@/utils/navs';
import { useLayoutNavStore } from '~/stores/layout-nav';
import { usePages } from '~/composables/pages';
import { useGlobalsStore } from '~/stores/globals';
import PtButton from '~/components/global/elements/PtButton.vue';

const layoutNavStore = useLayoutNavStore();
const globals = useGlobalsStore();
const navs = computed(() => layoutNavStore.navs);
const loginUrl = computed(() => globals.loginUrl);
const signUpUrl = computed(() => globals.signUpUrl);
const { displayNavigation } = usePages();

const getNav = (handle) => {
  const processItems = (items) =>
    items
      .map((item) => {
        const transformed = transformNavItem(item);
        if (!transformed) return null;
        return {
          ...transformed,
          hideTitle: item.hide_title || false,
          children: Array.isArray(item.children) && item.children.length ? processItems(item.children) : [],
        };
      })
      .filter((n) => n);

  return navs.value && navs.value.footer && navs.value.footer[handle] ? processItems(navs.value.footer[handle]) : [];
};

const nav = computed(() => getNav('nav'));
const secondaryNav = computed(() => getNav('secondary_nav'));
const shouldHideNavigation = ref(false);

onMounted(() => {
  shouldHideNavigation.value = displayNavigation.value;

  nextTick(() => {
    if (window.ds07o6pcmkorn) {
      const frameName = new window.ds07o6pcmkorn({
        openElementId: '#shielded-logo',
        modalID: 'modal',
      });
      frameName.init();
    }
  });
});

watch(displayNavigation, (val) => {
  shouldHideNavigation.value = val;
});
</script>
